import Breadcrumbs from "components/breadcrumbs";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import AppScreen from "../ScreenWithSidebar";
import MainCourses from "./components/main";

const CoursesByLevel = () => {

  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  return (
    <React.Fragment>
      <div style={{ marginTop: isMobile ? (!userHavingCalendar || userTeachingOrganismClass) ? "130px" : "70px" : "0px" }}>
        <Breadcrumbs isMycontent={true} />
        <AppScreen>
          <MainCourses />
        </AppScreen>
      </div>
    </React.Fragment>
  );
};

export default CoursesByLevel;
